import { Avatar } from '~/components/OddscheckerPlus/components/Avatar';
import { BetType } from '~/components/OddscheckerPlus/components/cxy';
import { type ValueBetResult } from '~/configuration/betting-insights/types';

import { trackBetTypeToolTipOpen } from '../tracking';

import styles from './styles/Profile.module.css';
import { AiBadge } from './AiBadge';

// TODO: Use CXY Profile

export type ProfileProps = {
  aiProjection?: ValueBetResult['aiProjection'];
  betName: ValueBetResult['betName'];
  line?: ValueBetResult['line'];
  marketClassification?: ValueBetResult['marketClassification'];
  marketDisplayName: ValueBetResult['marketDisplayName'];
  marketPropType: ValueBetResult['marketPropType'];
  resourcesUrl?: string;
  sportsData: ValueBetResult['sportsData'];
  teamData: ValueBetResult['teamData'];
  type?: ValueBetResult['type'];
};

const Profile = ({
  aiProjection,
  betName,
  line,
  marketClassification,
  marketDisplayName,
  marketPropType,
  resourcesUrl,
  sportsData,
  teamData,
  type
}: ProfileProps) => {
  return (
    <div className={styles.profile}>
			<div className={styles.betDetails}>
				<Avatar
          betName={betName}
          marketClassification={marketClassification}
          marketPropType={marketPropType}
          sportsData={sportsData}
          teamData={teamData} />

				<div className={styles.titleCell} id="bet-name">
					{line ?
          <>
							<h3 className={styles.titleHeading} data-testid="bet-name">
								{line.name}
							</h3>
							<p className={styles.titleText} data-testid="bet-market">
								{line.sign} {line.absolute} {marketDisplayName}
							</p>
							{aiProjection && resourcesUrl &&
            <AiBadge
              description={marketDisplayName}
              projection={aiProjection}
              resourcesUrl={resourcesUrl} />

            }
						</> :

          <>
							<h3 className={styles.titleHeading} data-testid="bet-name">
								{betName}
							</h3>
							<p className={styles.titleText} data-testid="bet-market">
								{marketDisplayName}
							</p>
							{aiProjection && resourcesUrl &&
            <AiBadge
              description={marketDisplayName}
              projection={aiProjection}
              resourcesUrl={resourcesUrl} />

            }
						</>
          }
				</div>
			</div>
			{type &&
      <BetType
        onOpenChange={(open) => {
          if (open) {
            trackBetTypeToolTipOpen({ props: type });
          }
        }}
        variant={type} />

      }
		</div>);

};

export { Profile };